export default function formatStartingTime(enumValue) {
  const map = {
    EIGHT_AM: '8:00AM',
    EIGHT_THIRTY_AM: '8:30AM',
    ELEVEN_AM: '11:00AM',
    ELEVEN_THIRTY_AM: '11:30AM',
    TWELVE_PM: '12:00PM',
    TWELVE_THIRTY_PM: '12:30PM',
    ONE_PM: '1:00PM',
    ONE_THIRTY_PM: '1:30PM',
    TWO_PM: '2:00PM',
    TWO_THIRTY_PM: '2:30PM',
    THREE_PM: '3:00PM',
    THREE_THIRTY_PM: '3:30PM',
    FOUR_PM: '4:00PM',
    FOUR_THIRTY_PM: '4:30PM',
  };
  
  return map[enumValue] || enumValue;
}
